import { FileReference } from 'Domain/Model/FileReference/FileReference';

export const FIND_FILE_REFERENCES_SUCCESS = 'FIND_FILE_REFERENCES_SUCCESS';

interface IFindFileReferencesSuccess {
  fileReferences: Record<string, FileReference>,
  request: {},
  response: {},
}

export const findFileReferencesSuccess = ({ fileReferences, request, response }: IFindFileReferencesSuccess) => ({
  type   : FIND_FILE_REFERENCES_SUCCESS,
  payload: { fileReferences },
  meta   : {
    request,
    response,
  }
});
